module.exports = __webpack_public_path__ + "static/media/Braum_0.18206535.jpg";